import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'ctm-components';
import { regoLookupLicencePlatePlaceholderSelector } from 'ctm-selectors/selectors/brand_content';
import {
    addressStateSelector,
    helpersRegoLabelSelector,
    vehicleStateSelector
} from 'ctm-selectors/selectors/form_payload';
import { RegistrationNumber } from './registration_number';
import states from './licence_plate_states.json';
import styles from './registration_number.css';

const RegistrationNumberContainer = ({ hideStateSelect }) => {
    const dispatch = useDispatch();
    const licencePlatePlaceholder = useSelector(regoLookupLicencePlatePlaceholderSelector);
    const [isInputFocused, setIsInputFocused] = useState(false);
    const rawVehicleState = useSelector(vehicleStateSelector);
    const rawAddressState = useSelector(addressStateSelector);
    const rego = useSelector(helpersRegoLabelSelector) || '';
    const vehicleState = hideStateSelect ? 'none' : rawVehicleState;
    const addressState = hideStateSelect ? 'none' : rawAddressState;
    const stateKey = 'vertical.quote';
    const selectProps = {
        schema: {
            stateKey,
            identifier: 'coverDetail.vehicle.state',
            field: {
                options: states
            }
        }
    };

    const setRego = (value) => {
        dispatch({
            type: 'SET_VALUE',
            value,
            identifier: 'coverDetail.vehicle.rego',
            stateKey: 'vertical.quote'
        });

    // If rego is empty omit rego and state fields from payload.
    if (!value) {
        dispatch({
            type: 'SET_VALUE',
            value:null,
            identifier: 'coverDetail.vehicle.rego',
            stateKey: 'vertical.quote'
        });
        dispatch({
            type: 'SET_VALUE',
            value: null,
            identifier: 'coverDetail.vehicle.state',
            stateKey: 'vertical.quote'
        });
    }

    };

    /**
     * Returns the input props for the Registration Numbers Input field
     * @returns {InputProp} returns InputProps
     */
    const getInputProps = () => {
        return {
            placeholder: isInputFocused ? '' : licencePlatePlaceholder,
            dispatch,
            value: rego,
            schema: {
                stateKey,
                identifier: 'helpers.regoLabel',
                field: {
                    type: 'text',
                    maxlength: 8
                }
            },
            onFocus: () => setIsInputFocused(true),
            onBlur: () => setIsInputFocused(false),
            onChange: (event, value) => setRego(sanitizeValue(value))
        };
    };

    /**
     * Sanitizes the rego value - removes anything that's not a number or letter
     * @param {string} value - the rego value
     * @returns {string} - the santized rego value
     */
    const sanitizeValue = (value) => value.replace(/[\W_]+/g, '');

    /**
     * fires a dispatch to set_value of address state to vehicle state
     */
    useEffect(() => {
        if (!vehicleState && !hideStateSelect) {
            dispatch({
                type: 'SET_VALUE',
                identifier: 'coverDetail.vehicle.state',
                value: addressState,
                stateKey
            });
        }
    }, []);

    return (
        <div>
            {
                !hideStateSelect
                && (
                    <div className={styles.select}>
                        <Select {...selectProps} value={vehicleState || addressState} />
                    </div>
                )
            }
            <RegistrationNumber
                state={vehicleState || addressState}
                inputProps={getInputProps()}
            />
        </div>
    );
};

RegistrationNumberContainer.propTypes = {
    hideStateSelect: PropTypes.bool
};

export { RegistrationNumberContainer };
